
import { FC } from "react";
import { Link, LinkProps } from "@xcorejs/ui";

export type TelLinkProps = LinkProps;

const TelLink: FC<TelLinkProps> = ({ children, ...props }) => (
  <Link color="inherit" border={0} _hover={{ border: 0, color: "inherit" }} {...props}>
    {children}
  </Link>
);

export default TelLink;
